import { fetchAllEntitiesForDownloadAction } from "../actions/fetchAllEntitiesForDownloadAction";

// ── CSV helpers ───────────────────────────────────────────────────────────────
const toCSV = (rows, columns) => {
  const header = columns.map((c) => `"${c.label}"`).join(",");
  const body = rows.map((row) =>
    columns
      .map((c) => {
        const val = c.value(row) ?? "";
        return `"${String(val).replace(/"/g, '""')}"`;
      })
      .join(","),
  );
  return [header, ...body].join("\r\n");
};

const triggerDownload = (csv, filename) => {
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-IN") : "");

const fmtBool = (v) => (v === true ? "Yes" : v === false ? "No" : "");

// ── Columns — mapped from actual API response fields ──────────────────────────

const PRIMARY_COLS = [
  { label: "Entity ID", value: (r) => r.entityId },
  { label: "Entity Name", value: (r) => r.entityName },
  { label: "Category", value: (r) => r.entityCategory },
  { label: "LOB Type", value: (r) => r.entityLOBType },
  { label: "AA Department", value: (r) => r.aaDepartmentFunction },
  { label: "Parent", value: (r) => r.parentName },
  { label: "Email", value: (r) => r.emailAddress },
  { label: "SPOC Email", value: (r) => r.spoC_EmailAddress },
  { label: "Contact Person", value: (r) => r.contactPersonName },
  { label: "Designation", value: (r) => r.designation },
  { label: "Mobile", value: (r) => r.mobileNumber },
  { label: "Entity Type", value: (r) => r.entityType },
  { label: "Require KYC", value: (r) => fmtBool(r.requireKYC) },
  { label: "Invoice Required", value: (r) => fmtBool(r.invoiceRequired) },
  { label: "Contact Email", value: (r) => r.contactPersonEmail },
  { label: "Status", value: (r) => (r.isVerified ? "Approved" : "Pending") },
];

const GST_COLS = [
  { label: "GST Registered", value: (r) => fmtBool(r.isGSTRegistered) },
  {
    label: "GST Numbers",
    value: (r) =>
      (r.gstList || [])
        .filter((g) => g.gstNumber)
        .map((g) => g.gstNumber)
        .join("; "),
  },
  {
    label: "GST States",
    value: (r) =>
      (r.gstList || [])
        .filter((g) => g.state)
        .map((g) => g.state)
        .join("; "),
  },
  {
    label: "GST Addresses",
    value: (r) =>
      (r.gstList || [])
        .filter((g) => g.gstAddress)
        .map((g) => g.gstAddress)
        .join("; "),
  },
];

const ADDRESS_COLS = [
  { label: "Trade Name", value: (r) => r.tradeName },
  { label: "Pin Code", value: (r) => r.pinCode },
  { label: "City", value: (r) => r.city },
  { label: "State", value: (r) => r.state },
  { label: "Address", value: (r) => r.address },
];

const KYC_COLS = [{ label: "PAN Number", value: (r) => r.panCardNumber }];

const ALL_COLS = [...PRIMARY_COLS, ...GST_COLS, ...ADDRESS_COLS, ...KYC_COLS];

// ── Public API ────────────────────────────────────────────────────────────────

export const downloadEntityData = async (filters = {}) => {
  console.log("[Download] Fetching with filters:", filters);

  const { success, data, error } =
    await fetchAllEntitiesForDownloadAction(filters);

  if (!success || !data.length) {
    alert(error ? `Download failed: ${error}` : "No data to download.");
    return;
  }

  console.log(
    "[Download] Records:",
    data.length,
    "| Columns:",
    ALL_COLS.length,
  );
  console.log(
    "[Download] Sample row:",
    ALL_COLS.reduce((acc, c) => {
      acc[c.label] = c.value(data[0]);
      return acc;
    }, {}),
  );

  const ts = new Date().toISOString().slice(0, 10);
  triggerDownload(toCSV(data, ALL_COLS), `entities_${ts}.csv`);
  console.log(
    `[Download] ✅ entities_${ts}.csv — ${data.length} rows, ${ALL_COLS.length} columns`,
  );
};
